module.exports = __webpack_public_path__ + "img/gouwuche.10d30cb7.png";